// @flow
import React, { useState, useEffect } from 'react';

import styles from './ArticlesSave.module.scss';
import getDatabg from '../../../controllers/handtips.controller';
import Video from '../../../components/Video/Video';

type IBG = {
  header: {
    textheader: string;
  };

  Content: {
    blockOne: {
      textboone: string;
      textbotwo: string;
      textbothree: string;
      imageUrl: string;
      textbofive: string;
      textbosix: string;
      textboseven: string;
      textboeight: string;
    };
    blockTwo: {
      blockHeaderbtwo: string;
      textbtwoone: string;
      textbtwotwo: string;
      textbtwothree: string;
      textbtfour: string;
      textbtfive: string;
      textbtsix: string;
      textbtseven: string;
      textbteight: string;
      textbtnine: string;
      textbtten: string;
      textbteleven: string;
    };
    blockThree: {
      localHeaderbthree: string;
      textbtone: string;
      textbttwo: string;
      textbtthree: string;
      textbtfour: string;
      textbtfive: string;
      textbtsix: string;
      textbtseven: string;
      textbteight: string;
      textbtnine: string;
      textbtten: string;
      textbteleven: string;
      textbttwelve: string;
      textbtthirteen: string;
      textbtfourteen: string;
      textbtfifteen: string;
      textbtsixteen: string;
      textbtseventeen: string;
      textbteighteen: string;
      textbtnineteen: string;
      textbttwenty: string;
      textbttwentyone: string;
      textbttwentytwo: string;
      textbttwentythree: string;
      textbttwentyfour: string;
      textbttwentyfive: string;
      textbttwentysix: string;
    };
  };
} | null

const ThreeArticle = () => {
  const [language, setLanguage] = useState<string>('');

  const [data, setData] = useState<IBG>([]);

  const getLanguage = () => {
    const locale = localStorage.getItem('i18nextLng');
    let languageKey;
    switch (locale) {
      case 'en':
        languageKey = 'Eng';
        break;
      case 'ru':
        languageKey = 'Rus';
        break;
      default:
        languageKey = 'Rus';
    }
    return languageKey;
  };

  useEffect(() => {
    setLanguage(getLanguage());
  }, []);

  const handleRes = async () => {
    const res = await getDatabg(getLanguage());

    setData(res);
  };

  useEffect(() => {
    handleRes();
  }, []);

  if (!data) return null;

  return (
    language
    && (
    <>
      <title>OmahaPro</title>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="true"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Staatliches&display=swap"
        rel="stylesheet"
      />
      <div id="root" className={styles.site}>
        <div className={styles.container}>
          <div className={`${styles.header} ${styles.bg_header}`}>
            <span className={styles.header_text}>
              В омашисты я б пошёл, пусть меня научат
            </span>
          </div>
          <div className={styles.content}>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Хотите изучать омаху, но не знаете, с чего начать? Вот вам
                первый урок: в пот лимитной омахе эквити рук на префлопе
                довольно близки. На постфлопе же всё может кардинально
                измениться, и именно выбор стартеров зачастую решает, кому уйдёт
                банк — нам или оппоненту.
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Мы решили узнать у тренеров GreenLine, как они в своё время
                изучали префлоп.
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Префлоп — это крепость, которую нужно брать штурмом, уверен
                тренер фонда Денис PoDoX.
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                “Вы можете учить префлоп-ренджи самостоятельно, но быстрее и
                проще это сделать в тренажёре. Тренируясь в OmahaPro, нужно
                сделать не менее 100 повторений по каждой позиции. Если по
                какой-то из позиций точность ответов меньше 95%, ребята, у меня
                для вас плохие новости: срочно выводите все деньги и не
                заводите, пока не добьётесь заветной цифры. Свои результаты вы
                можете отслеживать во вкладке Results. Когда на протяжении
                недели ваши результаты будут 95% и выше по ВСЕМ позициям, можете
                переходить к следующей игровой ситуации”.
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Тренер фонда Денис Gragik, доставивший немало хлопот
                легендарному Виктору Isildur1 в хедз-апе, советует нащупать
                границы ренджей: “Отмечайте как можно больше сомнительных раздач
                во время игры, а после сессии сверяйте свой префлоп с
                тренажёром. Может быть, с этой рукой вообще не стоило заходить в
                банк? Вы сами не заметите, как после пары тысяч раздач
                сформируется понимание границ ренджей. После этого попытайтесь
                угадать, какие руки являются пограничными в том или ином споте.
                Догадки сверьте с тренажёром”.
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Такой же подход исповедует регуляр PLO500-2К Сергей SooStronk.
                Каждую свою сессию на заре карьеры он завершал разбором базы —
                смотрел, как играют те или иные руки.
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Василий Falco советует понять логику префлопа: “Начните изучать
                префлоп с узких спектров и двигайтесь в сторону расширения. К
                примеру, изучите диапазоны открытия из MP и двигайтесь в сторону
                CO и BU. Обращайте внимание на то, за счёт каких рук
                увеличивается % открытия. Так вы не просто запомните конкретные
                руки, но и поймёте логику построения ренджей. То же самое
                касается и 3бет потов”
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Четыре тренера — четыре подхода. Мы обратились к создателям
                OmahaPro и попросили их рассказать, как правильно учить префлоп
                с помощью их продукта. Спойлер: их подход объединяет в себе
                советы от тренеров фонда и, на наш взгляд, является самым
                эффективным.
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                На сайте OmahaPro есть специальный раздел с обучающими
                материалами. Сразу две статьи посвящены тому, как правильно
                изучать префлоп. Какие руки и какие комбинации существуют в
                омахе, описано здесь
                <a
                  className={styles.link}
                  href="https://omahapro.com/articles"
                  target="_blank"
                >
                  {' https://omahapro.com/articles'}
                </a>
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                В одноименном разделе Preflop визуализация префлопа наглядно
                представлена, разбита на категории и по мастям
                <a
                  className={styles.link}
                  href="https://omahapro.com/cards"
                  target="_blank"
                >
                  {' https://omahapro.com/cards'}
                </a>
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Описание функционала можно посмотреть здесь
              </div>
            </div>
            <Video url="HvpANJSK1GA" />
            <div className={styles.bg_block}>
              <div className={styles.text}>
                В префлопе охвачены все основные позиции в 6-максе, в том числе
                и мультивей ситуации. Здесь же можете сверить свою игру с
                оптимальной
                <a
                  className={styles.link}
                  href="https://prnt.sc/knAANgYek_2o"
                  target="_blank"
                >
                  {' https://prnt.sc/knAANgYek_2o'}
                </a>
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Функция Compare служит нескольким целям. Основные — сравнение
                общих диапазонов с различных позиций или сравнение диапазонов
                различных стеков.
                <div>
                  <div>
                    <a
                      className={styles.link}
                      href="https://prnt.sc/yTkFwhrYKwpE"
                      target="_blank"
                    >
                      {' https://prnt.sc/yTkFwhrYKwpE'}
                    </a>
                  </div>
                  <div>
                    <a
                      className={styles.link}
                      href="https://prnt.sc/KZwgUgYH5wIp"
                      target="_blank"
                    >
                      {' https://prnt.sc/KZwgUgYH5wIp'}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Когда описанные выше этапы пройдены, можно переходить в
                тренажёр. Кстати, руки в нём расставлены в правильном порядке по
                номиналу и мастям. Именно такое чтение рук помогает интуитивно
                определить силу и слабость нашей руки во время игры, ускоряет
                запоминание префлопа.
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                С функционалом тренажера можно ознакомиться в этом видео
              </div>
            </div>
            <Video url="RD2lRq4hncM" />
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Из нового: в тренажер добавлен режим Smart Mode, который включён
                по умолчанию. В Smart Mode убраны очевидные руки, которые
                никогда не играются. Если вы допустили ошибку в решении,
                тренажёр в рандомном порядке будет повторять ошибочную руку до
                тех пор, пока вы её не исправите. В первый раз уведомление
                всплывёт с красным восклицательным знаком, во второй раз — с
                желтым.
                <div>
                  <div>
                    <a
                      className={styles.link}
                      href="https://prnt.sc/4Tcr-NROiXYl"
                      target="_blank"
                    >
                      {' https://prnt.sc/4Tcr-NROiXYl'}
                    </a>
                  </div>
                  <div>
                    <a
                      className={styles.link}
                      href="https://prnt.sc/9OfGAJ_ZCVDM"
                      target="_blank"
                    >
                      {' https://prnt.sc/9OfGAJ_ZCVDM'}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Есть возможность посмотреть весь кластер определённого типа рук
                в визуализации префлопа (нажав на See Range). Вам увидите, как
                реагировать на дальнейшие действия оппонента в позиции и без
                <a
                  className={styles.link}
                  href="https://prnt.sc/-TU-0HnZVTO7"
                  target="_blank"
                >
                  {' https://prnt.sc/-TU-0HnZVTO7'}
                </a>
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                В правой части экрана указано EV действия нашей руки, со всеми
                возможными вариациями мастей (наша конкретная рука выделена).
                Это научит вас интуитивно понимать границы ренджей.
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Для отслеживания результатов, поиска своих ликов на префлопе,
                предусмотрен режим Results. В нём указаны средние показатели за
                последний месяц и лучшие за всё время.
                <div>
                  <div>
                    <a
                      className={styles.link}
                      href="https://omahapro.com/results"
                      target="_blank"
                    >
                      {' https://omahapro.com/results'}
                    </a>
                  </div>
                  <div>
                    <a
                      className={styles.link}
                      href="https://prnt.sc/XGcw0ETsTSiw"
                      target="_blank"
                    >
                      {' https://prnt.sc/XGcw0ETsTSiw'}
                    </a>
                  </div>
                  <div>
                    <a
                      className={styles.link}
                      href="https://prnt.sc/E5Mkhq3CW1nT"
                      target="_blank"
                    >
                      {' https://prnt.sc/E5Mkhq3CW1nT'}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                В цветовой легенде указан уровень текущего освоения позиций в
                зависимости от результата.
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Визуализация Preflop поможет вам в кратчайшие сроки понять
                играемые диапазоны, Training — закрепить и отработать до мелочей
                полученные знания.
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Конечно, правильный префлоп в омахе — это лишь одна из
                составляющих плюсовой игры. Вы неизбежно будете совершать ошибки
                на постфлопе, но их будет гораздо меньше, чем у ваших
                оппонентов, играющих без ренджей.
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                Если хотите подтянуть свой постфлоп, то подписывайте на
                ютуб-канал GreenLine. Раз в две недели там выходят обучающие
                ролики по омахе. Смотрите, учитесь, растите по лимитам!
                <a
                  className={styles.link}
                  href="https://www.youtube.com/c/GreenlinePoker"
                  target="_blank"
                >
                  {' https://www.youtube.com/c/GreenlinePoker'}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
    )
  );
};

export default ThreeArticle;
